import React, { useState, useEffect } from 'react';
import { Editor } from '@tinymce/tinymce-react';

const PdfTemplateEditor = () => {
  const [content, setContent] = useState('');
  const [isCodeView, setIsCodeView] = useState(false);
  const BASEURL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetch(`${BASEURL}/pdf-template`)
      .then(res => res.json())
      .then(data => {
        if (data.template) setContent(data.template);
      });
  }, [BASEURL]);

  const saveTemplate = () => {
    fetch(`${BASEURL}/pdf-template`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ template: content }),
    })
      .then(() => alert('Template saved successfully!'))
      .catch(() => alert('Failed to save template.'));
  };

  return (
    <div style={{ maxWidth: 1200, margin: 'auto', padding: 20 }}>
      <h2>PDF Template Editor</h2>
      
      <div style={{ 
        backgroundColor: '#fff3cd', 
        border: '1px solid #ffc107', 
        borderRadius: 4, 
        padding: 15, 
        marginBottom: 20 
      }}>
        <strong>💡 Tip:</strong> This template uses Jinja2 syntax for dynamic content.
        <br />
        <strong>Available variables:</strong> {`{{ first_name }}`}, {`{{ last_name }}`}, {`{{ ptn_number }}`}, {`{{ exam_start_time }}`}, {`{{ city_of_birth }}`}, {`{{ date_of_birth }}`}, {`{{ exam_name }}`}
        <br />
        <strong>For loops:</strong> {`{% for row in exam_rows %}`} ... {`{% endfor %}`} - Access: {`{{ row.label }}`}, {`{{ row.room }}`}, {`{{ row.date }}`}, {`{{ row.time }}`}
      </div>

      <div style={{ marginBottom: 15 }}>
        <button
          onClick={() => setIsCodeView(!isCodeView)}
          style={{ 
            padding: '8px 16px', 
            cursor: 'pointer',
            backgroundColor: isCodeView ? '#28a745' : '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: 4,
            marginRight: 10,
          }}
        >
          {isCodeView ? '📝 Visual Editor' : '💻 Code View'}
        </button>
        <span style={{ color: '#666', fontSize: 14 }}>
          {isCodeView ? 'Currently in code view' : 'Currently in visual editor'}
        </span>
      </div>

      {isCodeView ? (
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          style={{
            width: '100%',
            height: 500,
            fontFamily: 'monospace',
            fontSize: 14,
            padding: 10,
            border: '1px solid #ccc',
            borderRadius: 4,
            whiteSpace: 'pre-wrap',
            overflowWrap: 'break-word',
            resize: 'vertical',
          }}
          spellCheck={false}
        />
      ) : (
        <Editor
          apiKey="jn8c0glzmwl1mnsucf54wiedkd9fln4qnabwqic2thcb8e0w"
          value={content}
          init={{
            height: 500,
            menubar: true,
            plugins: [
              'advlist autolink lists link image charmap preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste help wordcount'
            ],
            toolbar:
              'undo redo | formatselect | bold italic backcolor | ' +
              'alignleft aligncenter alignright alignjustify | ' +
              'bullist numlist outdent indent | removeformat | code | help',
            
            // CRITICAL: Prevent TinyMCE from encoding special characters
            entity_encoding: 'raw',  // Don't encode any entities
            entities: '',  // Don't convert any characters to entities
            verify_html: false,  // Don't validate/modify HTML
            valid_elements: '*[*]',  // Allow all elements and attributes
            extended_valid_elements: '*[*]',  // Allow all extended elements
            invalid_elements: '',  // Don't remove any elements
            
            // Preserve everything as-is
            protect: [
              /\{\{[\s\S]*?\}\}/g,  // Protect {{ variable }}
              /\{%[\s\S]*?%\}/g,     // Protect {% statements %}
            ],
            
            content_style: `
              body { 
                font-family: Verdana, Geneva, sans-serif; 
                margin: 20px; 
                color: #000; 
                line-height: 1.6;
              }
              .header { 
                margin-bottom: 20px; 
                display: flex;
                justify-content: space-between;
                align-items: center;
              }
              h2, h3, h4 { color: #1a1a1a; margin-top: 20px; }
              table { 
                border-collapse: collapse; 
                width: 100%; 
                margin: 20px 0; 
              }
              table, th, td { border: 1px solid #ccc; }
              th, td { 
                padding: 8px 12px; 
                text-align: left; 
              }
              th {
                background-color: #f8f9fa;
                font-weight: bold;
              }
              .footer { 
                margin-top: 40px; 
                font-size: 14px; 
              }
              a { 
                color: #0046be; 
                text-decoration: none; 
              }
              p { margin: 10px 0; }
              strong { font-weight: bold; }
            `,
          }}
          onEditorChange={(newContent) => setContent(newContent)}
        />
      )}

      <button
        onClick={saveTemplate}
        style={{ 
          marginTop: 15, 
          padding: '10px 20px', 
          fontSize: 16, 
          cursor: 'pointer',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: 4,
        }}
      >
        💾 Save Template
      </button>
    </div>
  );
};

export default PdfTemplateEditor;
